import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './auth/login/login.component';
import { ActivationComponent } from './pages/activation/activation.component';
import { ModalComponent } from './shared/modal/modal.component';
import { TablesComponent } from './shared/tables/tables.component';
import { AuthGuard } from './auth/_guards';
import { RelatoriosConteudoComponent } from './pages/relatorios/relatorios-conteudo/relatorios-conteudo.component';
import { RelatoriosColecaoComponent } from './pages/relatorios/relatorios-colecao/relatorios-colecao.component';
import { RelatoriosExternoComponent } from './pages/relatorios/relatorios-externo/relatorios-externo.component';
import { RelatorioDireitosComponent } from './pages/relatorios/relatorio-direitos/relatorio-direitos.component';
import { OrderCategoryComponent } from './pages/gestao/highlight/order-category/order-category.component';
import { LastReleasesComponent } from './pages/gestao/highlight/last-releases/last-releases.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login/:id',
    component: LoginComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'ativacao/:emailKey/:userId',
    component: ActivationComponent
  },
  {
    path: 'recuperacao/:emailKey/:userId',
    component: ActivationComponent
  },
  // otherwise redirect to home
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: {
      role: ['ADMIN', 'EDITOR', 'MANAGER']
    }
  },

  //configurações
  {
    path: 'configuracoes',
    data: {
      role: 'ADMIN'
    },
    children: [
      {
        path: 'api',
        loadChildren: () => import('./pages/configuracoes/api/api.module').then((m) => m.ApiModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'categoria-conteudo',
        loadChildren: () =>
          import('./pages/configuracoes/categoria-conteudo/categoria-conteudo.module').then(
            (m) => m.CategoriaConteudoModule
          ),
        canActivate: [AuthGuard]
      },
      {
        path: 'canal',
        loadChildren: () => import('./pages/configuracoes/canal/canal.module').then((m) => m.CanalModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'formato-arquivo',
        loadChildren: () =>
          import('./pages/configuracoes/file-format/file-format.module').then((m) => m.FileFormatModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'idioma',
        loadChildren: () => import('./pages/configuracoes/idioma/idioma.module').then((m) => m.LanguageModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'pais',
        loadChildren: () => import('./pages/configuracoes/pais/country.module').then((m) => m.CountryModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'tags',
        loadChildren: () => import('./pages/configuracoes/tag/tag.module').then((m) => m.TagModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'tipo-conteudo',
        loadChildren: () =>
          import('./pages/configuracoes/content-type/content-type.module').then((m) => m.ContentTypeModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'tipo-midia',
        // loadChildren: './pages/configuracoes/tipo-midia/tipo-midia.module#TipoMidiaModule',
        loadChildren: () => import('./pages/configuracoes/media-type/media-type.module').then((m) => m.MediaTypeModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'unidade',
        loadChildren: () => import('./pages/configuracoes/unidade/unidade.module').then((m) => m.UnidadeModule),
        canActivate: [AuthGuard]
      }
    ]
  },
  // Gestão
  {
    path: 'gestao',
    children: [
      {
        path: 'album',
        loadChildren: () => import('./pages/gestao/album/album.module').then((m) => m.AlbumModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'EDITOR', 'MANAGER']
        }
      },
      {
        path: 'colecao',
        loadChildren: () => import('./pages/gestao/collection/collection.module').then((m) => m.CollectionModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'EDITOR', 'MANAGER']
        }
      },
      {
        path: 'conteudo',
        loadChildren: () => import('./pages/gestao/content/content.module').then((m) => m.ContentModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'EDITOR', 'MANAGER']
        }
      },
      {
        path: 'conteudo-de-album',
        loadChildren: () => import('./pages/gestao/track/track.module').then((m) => m.TrackModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'EDITOR', 'MANAGER']
        }
      },
      {
        path: 'conteudo-externo',
        loadChildren: () =>
          import('./pages/gestao/conteudo-site/conteudo-site.module').then((m) => m.ConteudoSiteModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'EDITOR', 'MANAGER']
        }
      },
      {
        path: 'destaque',
        loadChildren: () =>
          import('./pages/gestao/highlight/highlight/highlight.module').then((m) => m.HighlightModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN']
        }
      },
      {
        path: 'destaque/programacao',
        loadChildren: () => import('./pages/gestao/highlight/schedule/schedule.module').then((m) => m.ScheduleModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN']
        }
      },
      {
        path: 'destaque/programacao-2',
        loadChildren: () =>
          import('./pages/gestao/highlight/schedule-2/schedule-2.module').then((m) => m.Schedule2Module),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN']
        }
      },
      {
        path: 'destaque/album',
        loadChildren: () =>
          import('./pages/gestao/highlight/album-highlight/album-highlight.module').then((m) => m.AlbumHighlightModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN']
        }
      },
      {
        path: 'destaque/ead-banner',
        loadChildren: () =>
          import('./pages/gestao/highlight/ead-banner/ead-banner.module').then((m) => m.EadBannerModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN']
        }
      },
      {
        path: 'destaque/app-banner',
        loadChildren: () =>
          import('./pages/gestao/highlight/app-banner/app-banner.module').then((m) => m.AppBannerModule),
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN']
        }
      }
      // {
      //   path: 'destaque/categoria',
      //   component: OrderCategoryComponent,
      //   canActivate: [AuthGuard],
      //   data: {
      //     role: ['ADMIN']
      //   }
      // },
      // {
      //   path: 'destaque/lancamentos',
      //   component: LastReleasesComponent,
      //   canActivate: [AuthGuard],
      //   data: {
      //     role: ['ADMIN']
      //   }
      // },
    ]
  },
  {
    path: 'relatorios',
    data: {
      role: ['ADMIN', 'EDITOR', 'MANAGER']
    },
    children: [
      {
        path: 'colecao',
        component: RelatoriosColecaoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'conteudo',
        component: RelatoriosConteudoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'conteudo-externo',
        component: RelatoriosExternoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'direitos-e-permissoes',
        component: RelatorioDireitosComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'gestao-usuarios',
    data: {
      role: ['ADMIN', 'MANAGER']
    },
    children: [
      {
        path: 'usuarios',
        loadChildren: () => import('./pages/gestao-usuarios/users.module').then((m) => m.UsersModule),
        canActivate: [AuthGuard]
      }
    ]
  }

  //   { path: "modal", component: ModalComponent },
  //   { path: "table", component: TablesComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
